import { CheckmarkCircleFilled, CrossCircleFilled, PlusCircleFilled } from '@creditornot/cb-icons';
import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type ImportSummaryProps = {
  importedFileName: string;
  numberOfErrors: number;
  numberOfUpdates: number;
  numberOfAdditions: number;
};

const Root = styled.div`
  background: ${cssThemedValue({ dark: colors.salt4, light: colors.pepper2 })};
  display: flex;
  padding: 24px;
  width: 100%;
`;

const InfoCell = styled.div`
  padding-inline: 24px;
  border-inline-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CellHeading = styled(T.Heading6)`
  display: inline-flex;
  gap: 8px;
  align-items: center;
`;

const CellBody = styled(T.Small)`
  color: ${cbSemanticCssVars.textSecondary};
`;

const ErrorIcon = styled(CrossCircleFilled)`
  width: 16px;
  fill: ${colors.strawberry100};
`;

const UpdateIcon = styled(CheckmarkCircleFilled)`
  width: 16px;
  fill: ${colors.wolt100};
`;

const AdditionIcon = styled(PlusCircleFilled)`
  width: 16px;
  fill: ${colors.lime100};
`;

export const ImportSummary = ({
  importedFileName,
  numberOfErrors,
  numberOfAdditions,
  numberOfUpdates,
}: ImportSummaryProps) => {
  return (
    <Root>
      <InfoCell>
        <CellHeading>
          <FormattedMessage id="shared-menu.editor.importer.summary.title" />
        </CellHeading>
        <CellBody>{importedFileName}</CellBody>
      </InfoCell>
      <InfoCell>
        <CellHeading>
          <ErrorIcon /> {numberOfErrors}
        </CellHeading>
        <CellBody>
          <FormattedMessage id="shared-menu.editor.importer.summary.rows-errors" />
        </CellBody>
      </InfoCell>
      <InfoCell>
        <CellHeading>
          <UpdateIcon /> {numberOfUpdates}
        </CellHeading>
        <CellBody>
          <FormattedMessage id="shared-menu.editor.importer.summary.rows-updates" />
        </CellBody>
      </InfoCell>
      <InfoCell>
        <CellHeading>
          <AdditionIcon /> {numberOfAdditions}
        </CellHeading>
        <CellBody>
          <FormattedMessage id="shared-menu.editor.importer.summary.rows-additions" />
        </CellBody>
      </InfoCell>
    </Root>
  );
};
